import { createAsyncThunk } from '@reduxjs/toolkit'

import { ILogoutData } from 'meta/auth'
import { AuthController } from 'controller/auth'

export const logout = createAsyncThunk<ILogoutData, void>('auth/logout', AuthController.logoutUser)
